import { authAxios } from '@components/Auth';
import { InsurancePolicyUserList } from '@models/InsurancePolicyUser';
import { API_V1_BASE } from '@config';
import { snakes } from '@utils/lodash';
import { WithParams, NumericString } from '@utils/typescript';
import { paginate, Pagination, PaginationParams } from '@models/Pagination';

export type GetAllInsurancePolicyUserParams = PaginationParams & WithParams<{
  insurancePolicyId: number;
  search?: string;
}>;;

export type CreateInsurancePolicyUserParams = WithParams<{
  insurancePolicyId: number;
  benefitTemplateId: number;
  name: string;
  dob: string;
  gender: string;
  premium: NumericString;
  refunded_premium: NumericString;
  activation_date: string;
  activation_period: string;
  description_html: string;
}>;

export type UpdateInsurancePolicyUserParams = Omit<CreateInsurancePolicyUserParams, 'insurancePolicyId'> & WithParams<{
  id: number;
}>;

export class InsurancePolicyUserApi {
  static getAll = async (params: GetAllInsurancePolicyUserParams) => {
    return await authAxios
      .get(`${API_V1_BASE}/user/insurance_policy_users`, { params: snakes(params) })
      .then((response) => paginate(response) as [InsurancePolicyUserList[], Pagination]);
  };

  static create = async (params: CreateInsurancePolicyUserParams) => {
    return await authAxios
      .postForm(`${API_V1_BASE}/user/insurance_policy_users`, snakes(params));
  };

  static update = async ({ id, ...params }: UpdateInsurancePolicyUserParams) => {
    return await authAxios
      .putForm(`${API_V1_BASE}/user/insurance_policy_users/${id}`, snakes(params));
  };
}
